import { SystemStyleObject } from '@chakra-ui/react';

export const createStyles = <T extends Record<string, SystemStyleObject>>(styles: T) => styles;
